import { render, staticRenderFns } from "./DetallesOtros.vue?vue&type=template&id=28fdd4d5&"
import script from "./DetallesOtros.vue?vue&type=script&lang=js&"
export * from "./DetallesOtros.vue?vue&type=script&lang=js&"
import style0 from "./DetallesOtros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDialog,VSimpleTable})
